import { render, staticRenderFns } from "./EditAddress.vue?vue&type=template&id=9eb9d1ae&scoped=true&"
import script from "./EditAddress.vue?vue&type=script&lang=js&"
export * from "./EditAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9eb9d1ae",
  null
  
)

export default component.exports